import { useQuery } from 'react-query'
import api from '../../services/api'

const fetchReport = (reportId) => api.get(`/report/${reportId}`).then((res) => res.data);

export default function useAccount(reportId) {
  return useQuery(['reports', reportId], () => fetchReport(reportId));
}